<template>
  <footer class="ss__custom__footer__wrapper">
    <div class="ss__custom__footer">
      <a
        href="/"
        class="ss__custom__footer__logo__wrapper">
        <SsCustomHeaderLogo class="ss__custom__footer__logo--desktop" viewBox="0 0 36 36"/>
        <SsCustomHeaderLogo class="ss__custom__footer__logo--mobile"/>
      </a>
      <div class="ss__custom__footer__media__links">
        <a
          class="ss__custom__footer__media__link__item"
          href="https://weibo.com/sspaime?is_hot=1"
          target="_blank">
          <i class="ssCommunityIcon__weibo"/>
        </a>
        <a
          href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU4Mjg3MDAyMQ==&subscene=0#wechat_redirect"
          target="_blank"
          id="ss__custom__footer__qrcode"
          class="ss__custom__footer__media__link__item"
          @click.prevent
          @mouseenter="featurePopoverVisible = true"
          @mouseleave="featurePopoverVisible = false">
          <i class="ssCommunityIcon__weixin"/>
          <SsFeaturePopover
            class="comp__SsFeaturePopover"
            :visible.sync="featurePopoverVisible"
            :showStar="false"
            :showClose="false"
            :spacing="0"
            transitionName="ssCustomFooterQrcode"
            title="关注公众号 sspaime"
            content="<img src='https://cdn-static.sspai.com/ui/gzh_qrcode_home.png' width='120'/>"
            :target="featurePopoverTarget"
          />
        </a>
        <a
          href="https://www.xiaohongshu.com/user/profile/63f5d65d000000001001d8d4"
          target="_blank"
          class="ss__custom__footer__media__link__item">
          <i class="ssCommunityIcon__xiaohongshu"/>
        </a>
        <a
          href="https://sspai.com/feed"
          target="_blank"
          class="ss__custom__footer__media__link__item">
          <i class="iconfont iconfont-rss-simple"/>
        </a>
      </div>
      <div class="ss__custom__footer__text__links__wrapper">
        <div class="ss__custom__footer__text__links">
          <a
            v-for="item in links"
            :key="item.name"
            :href="item.link"
            target="_blank">
            {{ item.name }}
          </a>
        </div>
        <div class="ss__custom__footer__record">
          <span>&copy; 2013-{{ year }} 深圳市烧麦网络科技有限公司 - 少数派</span>
          <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备09128966号-4</a>
          <span> | </span>
          <a href="https://dxzhgl.miit.gov.cn/" target="_blank">粤B2-20211534</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import SsCustomHeaderLogo from '../SsCustomHeaderLogo'
import SsFeaturePopover from '../SsFeaturePopover'
export default {
  name: 'SsCustomFooter',

  components: {
    SsCustomHeaderLogo,
    SsFeaturePopover
  },

  data () {
    return {
      links: [
        {
          name: '下载 App',
          link: 'https://sspai.com/page/client'
        },
        {
          name: '联系我们',
          link: 'mailto:contact@sspai.com'
        },
        {
          name: '商务合作',
          link: 'https://sspai.com/page/bussiness'
        },
        {
          name: '关于我们',
          link: 'https://sspai.com/page/about-us'
        },
        {
          name: '用户协议',
          link: 'https://sspai.com/page/agreement'
        }
      ],
      featurePopoverVisible: false,
      featurePopoverTarget: '#ss__custom__footer__qrcode'
    }
  },

  computed: {
    year () {
      return new Date().getFullYear()
    }
  },

  mounted () {
    let { height } = this.$el.getBoundingClientRect()
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.borderBoxSize) {
          height = entry.borderBoxSize[0].blockSize
        } else {
          height = entry.contentRect.height
        }
      }
      document.documentElement.style.setProperty('--height-SsCustomFooter', `${height}px`)
    })
    resizeObserver.observe(this.$el)
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/media.styl'
.ss__custom__footer__wrapper {
  background: var(--color-SsCustomFooter-bg, var(--B0-t));
}
.ss__custom__footer {
  box-sizing: border-box;
  width: 100%;
  padding: 32px 20px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 24px;
  @media (min-width: $screen-md) {
    max-width: 1232px;
    margin: auto;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    padding: 32px 16px;
  }

  a {
    color: inherit;
    &:hover, &:focus {
      color: inherit;
    }
  }

  .ss__custom__footer__logo__wrapper {
    display: flex;
    align-items: center;
  }

  .ss__custom__footer__logo--mobile {
    height: 32px;
    vertical-align: middle;
    @media (min-width: $screen-sm) {
      display: none;
    }
  }
  .ss__custom__footer__logo--desktop {
    display: none;
    vertical-align: middle;
    @media (min-width: $screen-sm) {
      display: inline-block;
      height: 32px;
    }
    @media (min-width: $screen-lg) {
      height: 36px;
    }
  }

  .ss__custom__footer__media__links {
    display: flex;
    column-gap: 20px;
    color: var(--color-SsCustomFooterMediaLink, var(--B6-t));
    font-size: 20px;
    .ss__custom__footer__media__link__item {
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    a {
      padding: 6px;
    }
    i {
      vertical-align: middle;
    }
  }

  .ss__custom__footer__text__links {
    display: flex;
    flex-wrap: wrap;
    row-gap: 12px;
    column-gap: 16px;
    font-size: 13px;
    margin-left: auto;
    margin-bottom: 24px;
    color: var(--color-SsCustomFooterTextLink, var(--B8-t));
    @media (min-width: $screen-sm) {
      margin-bottom: 4px;
    }
  }

  .ss__custom__footer__record {
    font-size: 10px;
    color: var(--color-SsCustomFooterRecord, var(--B5-t));
    @media (min-width: $screen-sm) {
      text-align: right;
    }
    span {
      margin-right: 4px;
    }
  }

  .ss__custom__footer__text__links__wrapper {
    @media (min-width: $screen-sm) {
      width: auto;
      margin: 0;
      margin-left: auto;
      display: flex;
      flex-direction: column;
    }
  }
}

.comp__SsFeaturePopover {
  --width-SsFeaturePopover: auto;
  --radius-SsFeaturePopover: 12px;
  >>> .popover__content {
    text-align: center;
    img {
      vertical-align: middle;
    }
  }
  >>> .ssCustomFooterQrcode-enter-active,
  >>> .ssCustomFooterQrcode-leave-active {
    opacity: 1;
    transform: translateY(0);
    transition: all var(--a-func-short) var(--a-dur-short);
  }
  >>> .ssCustomFooterQrcode-enter,
  >>> .ssCustomFooterQrcode-leave-to {
    opacity: 0;
    transform: translateY(10px);
    transition: all var(--a-func-short) var(--a-dur-short);
  }
}
</style>
